<template>
	<div ui-view="" class="app-body" id="view">
		<!-- ############ PAGE START-->
		<page-header title="출입 신청 조회" description="데이터센터 출입 신청 내역을 조회합니다."></page-header>

		<div class="page-body ph-30 book-search">
			<div class="pt-20 pb-20">

				<div class="row">
					<div class="search-item">
						<div class="input-group">
							<span class="input-group-addon title">이름</span>
							<input v-model="searchParams.visitorName"  type="text" class="form-control" placeholder="">
						</div>
					</div>

					<div class="search-item">
						<div class="input-group">
							<span class="input-group-addon title">이메일</span>
							<input v-model="searchParams.visitorEmail" type="text" class="form-control width-250" placeholder="" >
						</div>
					</div>

					<div class="search-item">
						<button class="btn btn-md blue ml-6" @click="searchClick()">검색</button>
					</div>
				</div>
			</div>

			<table class="tbl select-tbl">
				<colgroup>
					<col width="auto">
					<col width="auto">
					<col width="auto">
					<col width="auto">
					<col width="auto">
					<col width="auto">
					<col width="auto">
					<col width="42px">
				</colgroup>
				<thead>
				<th>출입요청기간</th>
				<th>이름</th>
				<th>회사명</th>
				<th>IDC</th>
				<th>신청일</th>
				<th>상태</th>
				<th>방문목적</th>
				<th></th>
				</thead>
				<tr v-if="!tableList || tableList.length == 0">
					<td colspan="8" style="text-align: center;">데이터가 없습니다.</td>
				</tr>

				<tbody v-for="(item, index) in tableList" :key="index">
				<tr :class="{ expanded :expanded == index }" @click="expand(index)">
					<td>{{ getDueDate(item.fromDate, item.toDate)}}</td>
					<td>{{ item.visitorName }}</td>
					<td>{{ item.visitorCompany }}</td>
					<td>{{ item.locationName }}</td>
					<td>{{ getDate(item.reservationTimestamp) }}</td>
					<td><i :class="['dot', getStatus(item.statusCode)]"></i>{{ item.visitStatus.statusStr }}</td>
					<td>{{ item.visitType != null ? item.visitType.visitTypeStr : ''}}</td>
					<td>
						<a>
							<i class="icon-arrow-line-down"></i>
							<i class="icon-arrow-line-up" :style="{display: expandArrow(index)}"></i>
						</a>
					</td>
				</tr>
				<tr class="detail hide">
					<td colspan="8">
						<h4>상세정보</h4>

						<div class="result-tbl m-t-sm">
							<table class="tbl">
								<tbody>
								<tr>
									<th>이름</th>
									<td>{{ item.visitorName }}</td>
									<th>회사명</th>
									<td>{{ item.visitorCompany }}</td>
								</tr>

								<tr>
									<th>출입 요청 기간 </th>
									<td>{{ getDueDate(item.fromDate, item.toDate) }}</td>
									<th>예약 신청일</th>
									<td>{{ getDate(item.reservationTimestamp) }}</td>
								</tr>

								<tr>
									<th>담당 임직원</th>
									<td>{{ item.empName }}</td>
									<th>방문 목적</th>
									<td>{{ item.visitType != null ? item.visitType.visitTypeStr : '' }}</td>
								</tr>

								</tbody>
							</table>
						</div>

						<div class="result-tbl" >
							<table class="tbl">
								<tbody>
								<tr>
									<th>출입 위치</th>
									<td>
										<div class="box border-box">
											<div class="scroll-wrap" ui-jp="mCustomScrollbar" data-mcs-theme="minimal-dark" ui-options="{theme:'minimal-dark'}" style="height: 150px;">
												<div class="box-body">
													<div v-if="item.statusCode != 1" v-for="(loc, index) in item.visitLocation" :key="index">
														<span class="mb-5 ">
															<i class="icon-complete success-mark mr-10"></i>{{loc[1]}} > {{loc[2]}} > {{loc[3]}}
														</span>
													</div>

													<div v-if="item.statusCode == 1"  >
														<span class="mb-5">
															<i class="icon-waiting mr-10"></i> 담담 임직원 출입 위치 승인 대기 중입니다.
														</span>
													</div>
												</div>
											</div>
										</div>
									</td>
									<th></th>
									<td></td>
								</tr>
								</tbody>
							</table>
						</div>

						<div class="result-tbl">
							<table class="tbl">
								<tbody>
									<tr>
										<th colspan="4">메모</th>
									</tr>
									<tr>
										<td colspan="4"> {{item.etc}} </td>
									</tr>
								</tbody>
							</table>
						</div>

						<h4 class="pt-20 pb-10">반입 요청 자산 정보</h4>
						<table class="tbl outline">
							<colgroup>
								<col width="auto">
								<col width="auto">
								<col width="auto">
								<col width="auto">
								<col width="auto">
							</colgroup>
							<thead>
							<tr>
								<th>항목</th>
								<th>제조사</th>
								<th>모델명</th>
								<th>시리얼번호</th>
								<th>비고</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(asset, assetIndex) in item.assetList" :key="assetIndex">
								<td>{{asset.visitorAssetCode.assetStr}}</td>
								<td>{{asset.assetManufacturer}}</td>
								<td>{{asset.assetModel}}</td>
								<td>{{asset.assetSerial}}</td>
								<td>{{asset.assetMemo}}</td>
							</tr>
							</tbody>
						</table>
					</td>
				</tr>
				</tbody>
			</table>
			<Pagenation ref="paging" :datasource="resultData" @pageChange="pageChange"/>
		</div>
	</div>
</template>

<script>
	import PageHeader from '@/layout/PageHeader.vue'
	import Pagenation from '@/components/common/Pagenation';
	import LocationList from './inOut/LocationList2.vue';

	export default {
		props: ['title', 'description'],
		components: {
			PageHeader,
			Pagenation,
			LocationList
		},
		data(){
			return {
				searchParams : {
					visitorName: null,
					visitorEmail: null
				},
				resultData: null,
				tableList: null,
				expanded: null,
				paging: this.$dataProvider.paging,
			}
		},
		computed: {
		},
		mounted(){
			this.init();
		},
		methods: {
			init(){
				debugger;
				let query = Object.assign({},this.$route.query);

				if(!query.limit || !query.offset){
					Object.entries(this.paging).forEach((data) => {
						query[data[0]] = data[1];
					});
					this.$router.push({query: query});
				}

				this.searchParams.visitorName = this.$route.query.visitorName ? this.$route.query.visitorName : '';
				this.searchParams.visitorEmail = this.$route.query.visitorEmail ? this.$route.query.visitorEmail : '';

				if(this.$route.query.visitorName && this.$route.query.visitorEmail) this.searchClick()


			},
			searchClick(){

				if(!this.searchParams.visitorEmail || this.searchParams.visitorEmail=='' ||!this.searchParams.visitorName || this.searchParams.visitorName==''  ){
					this.noti('잘못된 동작', '조회 할 이름, 이메일 정보를 입력해 주세요.', 'warning');
					return ;
				}

				let query = Object.assign({},this.$route.query);

				this.searchParams.limit = query.limit;
				this.searchParams.offset = query.offset;

				let payloadString = $.param(this.searchParams);


				this.$http.get('/api/public/visitor/reservationSearch?'+payloadString)
					.then((result) => {
						this.resultData = result.data;
						this.tableList = result.data.list;

						this.$nextTick(() => {
							$(".scroll-wrap").mCustomScrollbar({
								axis:"y" // horizontal scrollbar
							})
						});

					}).catch((e) =>{
				})
			},
			expand(index){
				if(this.expanded == index){
					this.expanded = null;
					return ;
				}
				this.expanded = index;
			},
			expandArrow(index) {
				return this.expanded == index ? 'inline' : 'none';
			},
			getStatus(statusCode){
				/*
        1.2 승인대기 - 노랑
        3, 5~8 승인완료 - 녹색
        4 승인 거절 - 회색
        */
				var color = 'grey'
				if(statusCode == 1 || statusCode == 2) color = 'yellow';
				else if(statusCode == 3 ) color = 'green';
				else if(statusCode == 5 || statusCode == 6) color = 'blue';
				else if(statusCode == 4 || statusCode == 7) color = 'red';
				return color;
			},
			pageChange(event){

				if(event) this.paging = event.data;

				let query = Object.assign({},this.$route.query);
				// this.searchTypeList.forEach((x) => {delete query[x.value]})
				query.limit = this.paging.limit;
				query.offset = this.paging.offset;
				this.$router.push({ path: this.$route.path, query: query}).then(() => {
					this.searchClick()
				});

			}
		}
	}
</script>

<style lang="scss" scoped>
</style>
